<template>
  <div class="bg">
    <div class="header_top">
      <img class="logo" src="@/assets/logo/ise_logo.png"></img>
      <div class="title">
        <div class="chinese">南京大学智能软件工程实验室</div>
        <div class="english">Nanjing University, Laboratory of Intelligent SoftWare Engineering</div>
      </div>
    </div>
    <!-- 主页导航栏 -->
    <div class="header_bottom">
      <el-menu mode="horizontal" background-color="#63065f" text-color="white" active-text-color="white" class="menu"
        router>
        <el-menu-item class="menu_item" index="/">首页</el-menu-item>
        <el-menu-item class="menu_item" index="/news/list">新闻资讯
        </el-menu-item>
        <el-menu-item class="menu_item" index="/activity/list">学术活动
        </el-menu-item>
        <el-menu-item class="menu_item" index="/member/list">成员介绍
        </el-menu-item>
        <el-submenu class="menu_item" index="7">
          <template #title>研究成果</template>
          <el-menu-item index="/platform/list">平台产品</el-menu-item>
          <el-menu-item index="/social_services/list"> 社会服务</el-menu-item>
          <el-menu-item index="/project">参与项目</el-menu-item>
          <el-menu-item index="/paper"> 论文发表</el-menu-item>
        </el-submenu>
        <el-menu-item class="menu_item" index="/about">关于我们</el-menu-item>
        <el-menu-item class="menu_item" index="/job/list">诚聘英才</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "mHeader"
};
</script>

<style scoped>
.el-header {
  height: 140px !important;
}

.bg {
  width: 100%;
}

.header_top {
  padding: 10px 0;
  width: 1200px;
  height: 60px;
  margin: 0 auto;
}

.header_top .logo {
  width: 60px;
  height: 60px;
  float: left;
}

.header_top .title {
  float: left;
  height: 58px;
  padding: 5px 0;
  margin-left: 10px;
  color: #63065f;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
}

.chinese {
  font-size: 23px;
}

.english {
  font-size: 10px;
}

.header_bottom {
  width: 100%;
  height: 60px;
  background-color: #63065f;
}

.menu_item {
  width: 170px;
  text-align: center;
}

.el-menu .el-menu-item {

  a:hover,
  a:link,
  a:visited,
  a:active,
  a:focus {
    text-decoration: none;
  }
}

.menu {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
</style>
